import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Card} from 'semantic-ui-react';
import {Actions} from '../../common/actions';
import {toUpperCase} from '../../common/util/fieldsNormalization';
import {checkNotFilledValues} from '../../common/util/fieldsValidation';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import Header from './header';
import BasicInfo from './info/basicInfo';
import Compatibility from './compatibility';
import StatusInfo from './info/statusInfo';
import ProductInfo from './info/productInfo';
import './partsMaster.scss';

class PartMasterForm extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartsMaster,
        scopes.Create
      )
    ) {
      this.props.history.push(paths.AccessDenied);
      return;
    }

    this.props.restorePartsFormValues();
    this.props.loadProviders({'withOrigin': true});
    this.props.loadOrigins();
    this.props.getPartGreyCarModels();
    this.props.getpartSCCList();

    const {partCode} = this.props;
    if (partCode) {
      this.props.changePartsFormValue('partCode', toUpperCase(partCode));
    }
  }

  handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }

    const {values} = this.props;
    const requiredFields = [
      'partClass',
      'partCode',
      'partName',
      'supplier',
      'productCode',
      'pnc',
      'priceTde',
      'pricePvp',
    ];
    if (checkNotFilledValues(values, requiredFields)) {
      this.props.addMessageBoxError('¡Llene los campos requeridos por favor!');
      return;
    }

    const messages = this.buildConfirmationMessages();

    if (messages.length) {
      this.props.togglePartFormConfirmation(true, messages);
      return;
    }

    this.savePartInfo(values);
  };

  buildConfirmationMessages = () => {
    const {values, previousPvpPrice, previousTdePrice} = this.props;
    const {company, priceTde, pricePvp} = values;
    const messages = [];

    if (
      company &&
      (previousPvpPrice !== pricePvp || previousTdePrice !== priceTde)
    ) {
      messages.push('Los precios fueron modificados.');
    }

    if (Number(pricePvp) < Number(priceTde)) {
      messages.push(
        'El precio de venta al público es menor al precio de Toyota.'
      );
    }

    return messages;
  };

  savePartInfo = (values) => {
    const payload = {...values};
    delete payload.haveFiles;

    if (!payload.company) {
      this.props.savePartMasterInfo(payload);
      return;
    }

    this.props.editPartMasterInfo(payload.partCode, payload);
  };

  render() {
    const {loading, loadingRejection, loadingFranchise} = this.props;
    const loadStatus = loading || loadingRejection || loadingFranchise;

    return (
      <Form
        className='parts-master'
        onSubmit={this.handleSubmit}
        loading={loadStatus}
      >
        <Card className='info' raised fluid>
          <Header />
          <BasicInfo />
        </Card>
        <StatusInfo />
        <Compatibility />
        <ProductInfo />
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    previousPvpPrice,
    previousTdePrice,
    values,
    factors,
    loading,
    loadingFranchise,
    loadingRejection,
  } = state.partsMaster || {};
  const {partCode} = ownProps.params;

  return {
    partCode,
    'permissions': state.session.permissions,
    values,
    factors,
    loading,
    loadingRejection,
    loadingFranchise,
    previousPvpPrice,
    previousTdePrice,
  };
};

const {
  changePartsFormValue,
  loadOrigins,
  loadProviders,
  getPartGreyCarModels,
  restorePartsFormValues,
  savePartMasterInfo,
  editPartMasterInfo,
  addMessageBoxError,
  togglePartFormConfirmation,
  getpartSCCList,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    changePartsFormValue,
    restorePartsFormValues,
    loadProviders,
    loadOrigins,
    getPartGreyCarModels,
    savePartMasterInfo,
    editPartMasterInfo,
    addMessageBoxError,
    togglePartFormConfirmation,
    getpartSCCList,
  })(PartMasterForm)
);
